import Routes from "../../router/Routes";

const Landing = () => {
  return (
    <>
      <h1>Landing page comes here</h1>
      <a href={Routes.home}>Go to Visualizer</a>
    </>
  );
};

export default Landing;
